var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.663 11.652c5.634 0 5.634 8.348 0 8.348H2v-8.348m4.663 0H2m4.663 0c5.634 0 5.634-7.652 0-7.652H2v7.652m11.111 2.81c0-3.059 1.989-5.539 4.445-5.539 2.455 0 4.444 2.48 4.444 5.538h-8.889Zm0 0C13.111 17.52 15.1 20 17.556 20c3.06 0 3.888-2.462 3.888-2.462m-1.11-12.307h-5.556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceLine);
export default __webpack_public_path__ + "static/media/behance_line.8c58fe631312f23acbf9077975f7e7bc.svg";
export { ForwardRef as ReactComponent };